import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgThermostat = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 22C10.6167 22 9.43767 21.5127 8.463 20.538C7.48767 19.5627 7 18.3833 7 17C7 16.2 7.175 15.454 7.525 14.762C7.875 14.0707 8.36667 13.4833 9 13V5C9 4.16667 9.29167 3.45833 9.875 2.875C10.4583 2.29167 11.1667 2 12 2C12.8333 2 13.5417 2.29167 14.125 2.875C14.7083 3.45833 15 4.16667 15 5V13C15.6333 13.4833 16.125 14.0707 16.475 14.762C16.825 15.454 17 16.2 17 17C17 18.3833 16.5127 19.5627 15.538 20.538C14.5627 21.5127 13.3833 22 12 22ZM11 11H13V10H12V9H13V7H12V6H13V5C13 4.71667 12.9043 4.479 12.713 4.287C12.521 4.09567 12.2833 4 12 4C11.7167 4 11.4793 4.09567 11.288 4.287C11.096 4.479 11 4.71667 11 5V11Z",
		fill: "currentColor"
	})
});
export default SvgThermostat;
